module.exports = __webpack_public_path__ + "img/userRes_g.09debe00.png";